import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-location';

import pageCatalog from 'pages/pageCatalog';
import './styles.css';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const gameScenario02 = require('common/assets/magicMovie/game-scenario-02.png');

export const MagicMovieScenario: React.FC = () => {
  const { t } = useTranslation(['magicMovie']);
  const navigate = useNavigate();

  return (
    <div id="game" className="gameContainer scenario" data-test-id="magicMovieScenarioRoot">
      <div className="limitLine gameContentContainer">
        <div style={{ flex: 2 }}>
          <h1 style={{ marginBottom: '20px' }}>
            <div className="scenarioImage" style={{ backgroundImage: 'url(' + gameScenario02 + ')' }}></div>

            {t('scenario.title')}
          </h1>
          <p className="blue" style={{ marginBottom: '40px', marginTop: 0 }}>
            {t('scenario.intro')}
          </p>

          <button
            className="customButton"
            style={{
              maxWidth: '400px',
              fontSize: '24px',
              padding: '20px',
              borderRadius: '4px',
              background: 'orange',
              color: '#16191F',
            }}
            onClick={() => {
              navigate({ to: pageCatalog['MagicMovieChallenge'].route });
            }}
            data-test-id="magicMovieScenarioContinueButton"
          >
            {t('scenario.continue')}
          </button>
        </div>
      </div>
    </div>
  );
};
